import "./style.css";

function ActionButton({ children, className, variant, selected, ...props }) {
    return <button className={`${variant == "sm" ? "action-button-sm" : "action-button"} ${className} ${selected ? "selected" : ""}`} {...props}>{children}</button>
}

export default ActionButton;